export default "__VITE_ASSET__Daf5BE2M__"